import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useRef, useState } from 'react';
import SignaturePad from 'react-signature-canvas';
import styled from 'styled-components';

import DeleteIcon from '../../../../../../../../assets/svg/DeleteIcon';
import { Text } from '../../../../../../../../react-components/Text';
import { SignatureBox } from './SignatureBox';

const SignaturePadPlaceholder = styled.div`
  width: 100%;
  height: 120px;
  border: 2px solid ${RoutalPalette.primary40};
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  &:after {
    width: 100%;
    height: calc(100% - 50px);
    position: absolute;
    content: '';
    border-left: 2px solid ${RoutalPalette.white};
    border-right: 2px solid ${RoutalPalette.white};
  }
  &:before {
    width: calc(100% - 50px);
    height: 100%;
    position: absolute;
    content: '';
    border-top: 2px solid ${RoutalPalette.white};
    border-bottom: 2px solid ${RoutalPalette.white};
  }
`;

type StopReportSignatureBoxProps = {
  signature?: string;
  onUpdateSignature: (...args: any[]) => any;
};

export const StopReportSignatureBox = ({ signature, onUpdateSignature }: StopReportSignatureBoxProps) => {
  const [signatureEnabled, setSignatureEnabled] = useState<boolean>(false);

  const sigPad = useRef<SignaturePad | null>(null);

  const onConfirm = () => {
    const signature = sigPad.current?.getTrimmedCanvas().toDataURL();
    onUpdateSignature(signature);
    setSignatureEnabled(false);
  };

  const onCancel = () => {
    onUpdateSignature(undefined);
    setSignatureEnabled(false);
  };
  const onDelete = () => {
    sigPad.current?.clear();
    onUpdateSignature(undefined);
  };

  return (
    <>
      {signature ? (
        <Grid container direction="column" wrap="nowrap" alignItems="flex-start">
          <SignaturePadPlaceholder onClick={() => onUpdateSignature(undefined)}>
            <img height="120px" style={{ maxWidth: `100%` }} src={signature} alt="" draggable="false" />
          </SignaturePadPlaceholder>

          <VSpacer small />

          <Grid
            onClick={() => onUpdateSignature(undefined)}
            style={{
              fontWeight: `normal`,
              display: `flex`,
              flexDirection: `row`,
              alignItems: `center`,
              alignSelf: `end`,
            }}
          >
            <DeleteIcon style={{ height: `15px`, width: `15px`, color: RoutalPalette.error.medium }} />

            <Text
              style={{
                marginLeft: `4px`,
                color: RoutalPalette.error.medium,
                fontSize: `13px`,
                fontWeight: `normal`,
              }}
              intlId="driver.stop.report.remove_signature_new_version"
            />
          </Grid>
        </Grid>
      ) : (
        <SignaturePadPlaceholder onClick={() => setSignatureEnabled(true)}>
          <Text
            variant="body-large"
            style={{
              color: RoutalPalette.secondary40,
            }}
            intlId="driver.stop.report.add_signature_new_version"
          />
        </SignaturePadPlaceholder>
      )}

      <SignatureBox
        open={signatureEnabled}
        sigPad={sigPad}
        signature={signature}
        onClose={onCancel}
        onConfirm={onConfirm}
        onDelete={onDelete}
        onUpdateSignature={onUpdateSignature}
      />
    </>
  );
};
